import { useSnackbar } from 'notistack'
import React, { FC, useState } from 'react'
import { DiscountTierPropsType, MarkupPropsType } from '../../../api/appAPI'
import { EnqueueSnackbarType, showMessage } from '../../common/Helpers'
import DiscountTierUIBox from './DiscountTierUIBox'

interface IProps {
  addTier(
    tProps: DiscountTierPropsType,
    enqueueSnackbar: EnqueueSnackbarType
  ): void
}

const DefineDiscountTier: FC<IProps> = (props) => {
  const [name, setName] = useState('')
  const [extraDiscountStartPoint, setExtraDiscountStartPoint] = useState(0)
  const [DPA_OfferCabinets, setDPA_OfferCabinets] = useState([0])
  const [PPFD_OfferCabinets, setPPFD_OfferCabinets] = useState([0])
  const [DPA_OfferSlatwallAndAcc, setDPA_OfferSlatwallAndAcc] = useState([0])
  const [PPFD_OfferSlatwallAndAcc, setPPFD_OfferSlatwallAndAcc] = useState([0])
  const [DPA_OfferOverheadStorage, setDPA_OfferOverheadStorage] = useState([0])
  const [PPFD_OfferOverheadStorage, setPPFD_OfferOverheadStorage] = useState([
    0,
  ])

  const { enqueueSnackbar } = useSnackbar()

  const handleNameChange = (event: React.ChangeEvent<{ value: string }>) => {
    setName(event.target.value.replace(/['"]/, ''))
  }

  const handleExtraDiscountStartPointChange = (
    event: React.ChangeEvent<{ value: number }>
  ) => {
    setExtraDiscountStartPoint(event.target.value)
  }

  const handleCreateClick = () => {
    if (name === '') {
      showMessage(enqueueSnackbar, 'Enter tier name')
      return
    }

    if (DPA_OfferCabinets.length !== PPFD_OfferCabinets.length) {
      showMessage(
        enqueueSnackbar,
        'The number of the values of DPA_OfferCabinets and PPFD_OfferCabinets must be equal'
      )
      return
    }

    if (DPA_OfferSlatwallAndAcc.length !== PPFD_OfferSlatwallAndAcc.length) {
      showMessage(
        enqueueSnackbar,
        'The number of the values of DPA_OfferSlatwallAndAcc and PPFD_OfferSlatwallAndAcc must be equal'
      )
      return
    }

    if (DPA_OfferOverheadStorage.length !== PPFD_OfferOverheadStorage.length) {
      showMessage(
        enqueueSnackbar,
        'The number of the values of DPA_OfferOverheadStorage and PPFD_OfferOverheadStorage must be equal'
      )
      return
    }

    const tierProps = {
      name,
      extraDiscountStartPoint,
      DPA_OfferCabinets,
      PPFD_OfferCabinets,
      DPA_OfferSlatwallAndAcc,
      PPFD_OfferSlatwallAndAcc,
      DPA_OfferOverheadStorage,
      PPFD_OfferOverheadStorage,
    } as DiscountTierPropsType

    props.addTier(tierProps, enqueueSnackbar)

    setName('')
    setExtraDiscountStartPoint(0)
    setDPA_OfferCabinets([0])
    setPPFD_OfferCabinets([0])
    setDPA_OfferSlatwallAndAcc([0])
    setPPFD_OfferSlatwallAndAcc([0])
    setDPA_OfferOverheadStorage([0])
    setPPFD_OfferOverheadStorage([0])
  }

  return (
    <DiscountTierUIBox
      title="New Discount Tier"
      name={{
        value: name,
        onChange: handleNameChange,
      }}
      extraDiscountStartPoint={{
        value: extraDiscountStartPoint,
        onChange: handleExtraDiscountStartPointChange,
      }}
      DPA_OfferCabinets={{
        value: DPA_OfferCabinets,
        onChange: setDPA_OfferCabinets,
      }}
      PPFD_OfferCabinets={{
        value: PPFD_OfferCabinets,
        onChange: setPPFD_OfferCabinets,
      }}
      DPA_OfferSlatwallAndAcc={{
        value: DPA_OfferSlatwallAndAcc,
        onChange: setDPA_OfferSlatwallAndAcc,
      }}
      PPFD_OfferSlatwallAndAcc={{
        value: PPFD_OfferSlatwallAndAcc,
        onChange: setPPFD_OfferSlatwallAndAcc,
      }}
      DPA_OfferOverheadStorage={{
        value: DPA_OfferOverheadStorage,
        onChange: setDPA_OfferOverheadStorage,
      }}
      PPFD_OfferOverheadStorage={{
        value: PPFD_OfferOverheadStorage,
        onChange: setPPFD_OfferOverheadStorage,
      }}
      onButtonClick={handleCreateClick}

      // editable
    />
  )
}

export default DefineDiscountTier
